import "./empty-record.style.scss";

// image
import emptyRecord from "../../assets/no-record.png";

interface EmptyRecordProps {
	caption?: string;
}

function EmptyRecord({ caption = "Looks like you don't have any records" }: EmptyRecordProps) {
	return (
		<div className="empty-container">
			<img src={emptyRecord} alt="empty" />
			<div className="empty-message">{caption}</div>
		</div>
	);
}

export default EmptyRecord;
